import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Features from './components/Features';
import Reviews from './components/Reviews';
import BookingCTA from './components/BookingCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Features />
      <Reviews />
      <BookingCTA />
      <Footer />
    </div>
  );
}
